import {
  CodeBracketIcon,
  ChartBarIcon,
  BoltIcon
} from '@heroicons/react/24/outline';
import IntegrationLandingPage from '@/components/integrations/IntegrationLandingPage';
import { getIntegrationsI18nProps } from '@/utils/i18n';
import { useTranslations } from 'next-intl';

export default function CustomApiIntegrationPage() {
  const t = useTranslations('integrations.customApi');
  const stats = [
    { title: t('stats.platformSupport.title'), value: t('stats.platformSupport.value'), hint: t('stats.platformSupport.hint'), icon: CodeBracketIcon },
    { title: t('stats.eventTracking.title'), value: t('stats.eventTracking.value'), hint: t('stats.eventTracking.hint'), icon: ChartBarIcon },
    { title: t('stats.deployment.title'), value: t('stats.deployment.value'), hint: t('stats.deployment.hint'), icon: BoltIcon }
  ];
  const features = t.raw('features');
  const steps = t.raw('steps');
  const faqs = t.raw('faqs');

  return (
    <IntegrationLandingPage
      seo={{
        title: t('seo.title'),
        description: t('seo.description'),
        keywords: t('seo.keywords'),
        url: '/custom-api-integration'
      }}
      badge={t('badge')}
      title={t('title')}
      subtitle={t('subtitle')}
      primaryCta={{ label: t('cta.primary'), href: '/signup' }}
      secondaryCta={{ label: t('cta.secondary'), href: '/contact' }}
      heroPanel={{
        media: (
          <img
            src="/integration/script-integration.webp"
            alt="Custom script and API integration"
            className="h-auto w-full object-contain"
          />
        )
      }}
      stats={stats}
      featuresTitle={t('section.featuresTitle')}
      featuresSubtitle={t('section.featuresSubtitle')}
      features={features}
      stepsTitle={t('section.stepsTitle')}
      stepsSubtitle={t('section.stepsSubtitle')}
      steps={steps}
      experienceTitle={t('section.experienceTitle')}
      experienceDescription={t('section.experienceDescription')}
      experienceBullets={t.raw('section.experienceBullets')}
      faqTitle={t('section.faqTitle')}
      faqSubtitle={t('section.faqSubtitle')}
      faqs={faqs}
      bottomCtaTitle={t('section.bottomCtaTitle')}
      bottomCtaSubtitle={t('section.bottomCtaSubtitle')}
      bottomPrimaryCta={{ label: t('section.bottomPrimaryCta'), href: '/signup' }}
      bottomSecondaryCta={{ label: t('section.bottomSecondaryCta'), href: '/contact' }}
    />
  );
}

export const getStaticProps = getIntegrationsI18nProps;
